<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import StatusBadge from '@/components/common/purchase-order-status-badge.vue';

export default {
  inject: ['setLoading'],
  components: {
   StatusBadge 
  },
  data() {
    return {
      title: "Inventory",
      text: "Inventory",
      data: [],
      users: [],
      app_currency: '',
      status_data: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
      filter: {
       status: '', 
       to_date: '',
       from_date: '',
       search: '',
      },
      loading: false,
      module_url: 'inventory/purchase-orders',
    };
  },

  computed: {
   text1(){
    return `Purchase Orders (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

  async mounted(){
   this.app_currency = await this.$appCurrency();
   this.filter.status = this.$route.query.status || '';
   this.loadAll();

   const start = moment().subtract(29, "days");
   const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    //this.setDateRange(start, end);
    
  }, 

  methods: {

    async loadAll(){
     this.statusData();   
     this.purchaseOrders(); 
    },

    async selectStatus(status){
     this.filter.status = status;
     await this.purchaseOrders();
    },

    async statusData(){
     try{
      const response = await axios.get(`/${this.module_url}/status-wise/data`);
      this.status_data = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }
    },

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

    async purchaseOrders(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       status: this.filter.status,
       to_date: this.filter.to_date,
       from_date: this.filter.from_date,
       per_page: this.pagination.per_page,
       search: this.filter.search.trim() || ''
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/${this.module_url}?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

   changePage(url){
    if (!url) return;
    const page = new URL(url).searchParams.get("page");
    this.purchaseOrders(page);
   },

   clearFilter(){
    this.filter.status = '';
    this.filter.to_date = '';
    this.filter.from_date = '';
    this.filter.search = '';
    this.purchaseOrders();
   }
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <!-- <div class="me-2 mb-2" v-if="pagination.total">
        <div class="dropdown">
        <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown"><i class="ti ti-file-export me-1"></i>Export
        </a>
        <ul class="dropdown-menu dropdown-menu-end p-3">
        <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
        </li>
        </ul>
        </div>
        </div> -->
        
        <div class="mb-2">
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#purchase_order_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.purchaseOrderModal.purchaseOrder();">
            <i class="ti ti-circle-plus me-2"></i>Add Purchase Order
          </a>
        </div>
       
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="row">

   <div class="col-md-3 cursor-pointer" v-for="(row, index) in status_data" :key="index" @click="selectStatus(row.status);">
    <div class="card flex-fill">
    <div class="card-body">
    <div class="d-flex align-items-center overflow-hidden mb-2">
    <div>
      <p class="fs-12 fw-normal mb-1 text-truncate">{{row.status}}</p>
      <h5>{{app_currency.code}} {{row.amount}}</h5>
    </div>
    </div>
    <div class="attendance-report-bar mb-2">
    <div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="height: 5px;">
      <div :class="`progress-bar ${row.bg_color}`" :style="`width: ${row.percentage}%;`"></div>
    </div>
    </div>
    <div>
    <p class="fs-12 fw-normal d-flex align-items-center text-truncate"><span class="text-muted fs-12 d-flex align-items-center me-1">Total: {{row.count}}</span></p>
    </div>
    </div>
    </div>
   </div> 

  </div>


    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-center flex-wrap row-gap-3">
    <!-- <h5>Payments List</h5> -->
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-1" v-if="filter.search || filter.from_date || filter.to_date || filter.status">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3">
    <vue-select
      v-model="filter.status"
      :options="[
        { label: 'Draft', value: 'draft' },
        { label: 'Approved', value: 'approved' },
        { label: 'Received', value: 'received' },
        { label: 'Partial', value: 'partial' },
        { label: 'Completed', value: 'completed' },
      ]"
      label="label"
      :reduce="s => s.value"
      placeholder="Status"
      :clearable="true"
      @update:modelValue="purchaseOrders()"
      style="min-width: 180px;"
    ></vue-select>
  </div>


    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="filter.search" placeholder="Search...."/>
    </div>
    </div>

    <div class="">
     <button type="button" class="btn btn-dark" @click="purchaseOrders()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

<div class="card-body card-table-wrapper">
 <div class="custom-datatable-filter table-responsive" v-if="data?.length">
  <table class="card-table">
   <thead>
    <tr>
      <th>#</th>
      <th>PO No</th>
      <th>Status</th>
      <th>Vendor</th>
      <th>Warehouse</th>
      <th>Total Amount</th>
      <th>Date</th>
      <th>Actions</th>
    </tr>
   </thead>
   <tbody>
    <tr v-for="(row, index) in data" :key="row.id">
     <td>{{ serialNo + index + 1 }}.</td>  
     <td>
      <h6>
       <a :href="`/inventory/purchase-order/view/${row.public_token}`" target="_blank" class="text-primary">{{ row.po_number }}</a>
      </h6>
     </td>
     <td><StatusBadge :status="row.status"></StatusBadge></td>
     <td><a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#vendor_detail_modal" @click="$refs.vendorModal.vendor(row?.vendor);" class="text-primary">{{ row?.vendor?.name }} - {{ row?.vendor?.code }}</a></td>
     <td><a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#warehouse_detail_modal" @click="$refs.warehouseModal.warehouse(row?.warehouse);">{{ row?.warehouse?.name }} - {{ row?.warehouse?.code }}</a></td>
     <td>{{ app_currency.code+" "+row.total_amount }}</td>
     <td>{{ $formatDate(row.created_at, 'DD-MM-YYYY') }}</td>
     <td>
     <div class="dropdown">
      <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
      <i class="ti ti-dots-vertical"></i>
      </button>
      <ul class="dropdown-menu dropdown-menu-end p-3">
      <li v-if="row.status === 'draft'">
      <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#purchase_order_modal" @click="$refs.purchaseOrderModal.purchaseOrder(row?.public_token)"><i class="ti ti-edit me-1"></i>Edit</a>
      </li>

      <li>
       <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#purchase_order_activity_modal" @click="$refs.purchaseOrderModal.purchaseOrderActivity(row)"><i class="ti ti-activity me-1"></i>History</a>
      </li>

      <li v-if="row.status !== 'completed'">
       <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#purchase_order_receive_stock_modal" @click="$refs.purchaseOrderModal.receiveStock(row)"><i class="ti ti-stack-push me-1"></i>Receive Stock</a>
      </li>
     
      <li>
      <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#purchase_order_delete_modal" @click="$refs.purchaseOrderModal.purchaseOrder(row.public_token)"><i class="ti ti-trash me-1"></i>Delete</a>
      </li>
      </ul>
      </div>  
      </td>

    </tr>
   </tbody>
  </table>

    <!-- Pagination -->
  <nav v-if="pagination?.links?.length > 3" class="mt-2 margin-l-2">
    <ul class="pagination pagination-sm">
    <li v-for="(link, index) in pagination.links" :key="index" :class="['page-item', { active: link.active, disabled: !link.url }]">
      <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
    </li>
    </ul>
  </nav>

  </div>

  <div v-else class="p-3 text-center text-muted"> No records found.</div>
  
</div>

</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<vendor-modal ref="vendorModal"></vendor-modal>
<warehouse-modal ref="warehouseModal"></warehouse-modal>
<purchase-order-modal ref="purchaseOrderModal" @updated="loadAll"></purchase-order-modal>
</template>

<style scoped>
    .table-responsive {
        overflow-y: auto;
    }
</style>